<template>
	<div class="bodycont">
		<div class="mesgcont Pub_width Pub_flexrow">
			<div class="mesgrich">
				<div class="richtext" v-html="richtext.content"></div>
				
			</div>
			<div class="map">
				<div class="mapcont">
					<div class="maptitle">{{maptitle}}</div>
					<div id="container"></div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	export default({
		data(){
			return{
				richtext:{},
				maptitle:""
			}
		},
		methods:{
			loaddetail(){
				this.$Get('api.php/about/49').then(res=>{
					console.log(res)
					this.richtext=res.data.data
				})
				this.$Get('api.php/cms/company/name/jingweidu').then(res=>{
				    let late=res.data.data.split(",")
					this.loadmap(late[0],late[1]);
				
				})
				this.$Get('api.php/cms/company/name/other').then(res=>{
				    this.maptitle=res.data.data
				})
				
			},
			loadmap(late_num,longte_num){
				 var map = new BMapGL.Map('container');
				 map.centerAndZoom(new BMapGL.Point(late_num,longte_num), 15);
				 map.enableScrollWheelZoom(true);
				 // 创建点标记
				 var marker1 = new BMapGL.Marker(new BMapGL.Point(late_num,longte_num));
				 // 在地图上添加点标记
				 map.addOverlay(marker1);	
			}
		},
		created() {
			this.loaddetail()
		},
		mounted() {
			this.loadmap()
		}
	})
</script>

<style scoped="scoped">
	.mesgcont{
		background: white;
		min-height: 500px;
		margin-top: 20px;
	}
	.map{
		width: 600px;
		height: 500px;
		display: flex;
		justify-content: center;
		align-items: center;
	}
	.mapcont{
		width: 447px;
		height: 400px;
	    border: 1px solid #f9e0e2;
	    border-radius: 5px;
	    padding: 10px 20px 10px 20px;
	    margin-bottom: 0px;
	}
	.maptitle{
		font-size: 15px;
		padding: 10px 0px 10px 0px;
	}
	#container{
		width: 447px;
		height: 300px;
	}
	.mesgrich{
		width: 600px;
	}
	.richtext{
		padding: 20px;
		
	}
</style>



// WEBPACK FOOTER //
// src/view/call_us.vue